export const authRoles = {
  sa: ["SA", "SUPER_ADMIN", "ROLE_SUPER_ADMIN"],
  admin: ["SA", "ADMIN", "MEMBRE", "MEMBER", "ROLE_ADMIN", "ROLE_MEMBER"],
  editor: ["SA", "ADMIN", "EDITOR", "ROLE_EDITOR"],
  guest: ["SA", "ADMIN", "EDITOR", "GUEST", "ROLE_GUEST"]
};

const normalizeRoleValue = (value) => {
  if (!value) return "";
  return String(value)
    .trim()
    .toUpperCase()
    .replace(/^ROLE_/, "")
    .replace(/\s+/g, "_");
};

export const normalizeUserRole = (user = {}) => {
  const directRole = user?.role || user?.roles?.[0];
  const roleCandidates = [user?.role, user?.roles?.[0], user?.roleName, user?.userRole, user?.type]
    .filter(Boolean);

  const normalized = roleCandidates.map(normalizeRoleValue);
  if (normalized.includes("SUPER_ADMIN") || normalized.includes("SA")) return "SA";
  if (normalized.includes("ADMIN") || normalized.includes("MEMBRE") || normalized.includes("MEMBER")) return "ADMIN";
  if (normalized.includes("EDITOR")) return "EDITOR";
  if (normalized.includes("GUEST")) return "GUEST";

  const directValue = normalizeRoleValue(directRole);
  if (directValue === "MEMBRE" || directValue === "MEMBER") return "ADMIN";
  if (directValue === "SUPER_ADMIN" || directValue === "ROLE_SUPER_ADMIN") return "SA";

  return normalized[0] || "";
};

export const hasRequiredRole = (user = {}, allowedRoles = []) => {
  if (!user) return false;
  if (!allowedRoles?.length) return true;

  const normalizedRole = normalizeUserRole(user);
  if (!normalizedRole) return true;

  return allowedRoles.some((role) => {
    const normalizedAllowed = normalizeRoleValue(role);
    return authRoles[normalizedAllowed?.toLowerCase()]?.includes(normalizedRole);
  });
};
